import React from "react";
import { Route, HashRouter } from "react-router-dom";
import Info from "./components/Info";
import Logo from "./components/Logo";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Slide from "./components/Slide";
import PopUp from "./components/InfoPopup";
import About from "./components/About";
import Services from "./components/Services";
import Products from "./components/Products";
import Appointment from "./components/Appointment";
import Impressum from "./components/Impressum.js";
import Privacy_Policy from "./components/Privacy-policy";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <div id="site">
          {/* <div id="infoPopup">
            <PopUp />
          </div> */}
          <div id="infoRow">
            <Info />
          </div>
          <div id="infoPopup">{/* <PopUp />*/}</div>
          <div id="headerWrapper">
            {/*<div id="ornamentLeft"></div>*/}
            <div>
              <Logo />
            </div>
            {/*<div id="ornamentRight"></div>*/}
          </div>
          <div></div>
          <div id="menu">
            <Menu />
          </div>
          <div id="content">
            <Route exact path="/" component={Slide} />
            <Route path="/services" component={Services} />
            <Route path="/products" component={Products} />
            <Route path="/appointment" component={Appointment} />
            <Route path="/about" component={About} />
            <Route path="/imprint" component={Impressum} />
            <Route path="/privacy-policy" component={Privacy_Policy} />
          </div>
          <div id="footerWrapper">
            <div id="footer">
              <Footer />
            </div>
          </div>
        </div>
      </HashRouter>
    </div>
  );
}

export default App;
